import { useFormContext, Controller } from 'react-hook-form';
import { AdminFormRow } from '@ui';
import { TmdxTextarea } from '@ds';
import { FacilityLocationDetails } from '@lp/features/admin/forms/components/FacilityLocationDetails';
import { FacilityAdminFormSection } from '@lp/features/admin/forms/components/sections';
import { MAX_LENGTH_2000 } from '@/constants/form.constants';
import { NewTXCenterForm } from '../types';
import { TXCenterBasicDetails } from './TXCenterBasicDetails';
import { TXCenterPrograms } from './TXCenterPrograms';
import { TXCenterFixedPriceContract } from './TXCenterFixedPriceContract';

type TxCenterFormType = {
  isReadOnly?: boolean;
  isNotesReadOnly?: boolean;
  isQadCustomerIdReadOnly?: boolean;
};

export const TXCentersForm = ({
  isReadOnly = false,
  isNotesReadOnly = false,
  isQadCustomerIdReadOnly = false,
}: TxCenterFormType) => {
  const { control } = useFormContext<NewTXCenterForm>();

  return (
    <FacilityAdminFormSection title="TX Center Details" isReadOnly={isReadOnly}>
      <TXCenterBasicDetails isReadOnly={isReadOnly} isQadCustomerIdReadOnly={isQadCustomerIdReadOnly} />
      <FacilityLocationDetails isReadOnly={isReadOnly} />
      <AdminFormRow title="Notes" center={false}>
        <Controller
          name="notes"
          control={control}
          render={({ field, fieldState: { invalid, error } }) => (
            <TmdxTextarea
              fullWidth
              disableAnimation
              minRows={2}
              aria-label="Notes"
              isInvalid={invalid}
              errorMessage={error?.message}
              isDisabled={isNotesReadOnly}
              className="min-h-16"
              maxLength={MAX_LENGTH_2000}
              {...field}
            />
          )}
        />
      </AdminFormRow>
      <TXCenterPrograms isReadOnly={isReadOnly} isNotesReadOnly={isNotesReadOnly} />
      <TXCenterFixedPriceContract />
    </FacilityAdminFormSection>
  );
};
